export const foucsOnElement = (el: any): void => {
    el?.scrollIntoView({ block: 'center', inline: 'nearest'});
};

export const isVerticallyInViewport = (el: HTMLElement | null): boolean => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top >= 0 && rect.bottom + 100 <= viewportHeight;
};

export const foucsOnElementIfNeeded = (el: HTMLElement | null): void => {
    if (!el) return;
    if (isVerticallyInViewport(el)) {
        // Already vertically in view — only align horizontally, not block
        el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    } else {
        el.scrollIntoView({ block: 'center', inline: 'nearest' });
    }
};

export const focusOnElementEnd = (el: any): void => {
    el?.scrollIntoView({ block: 'end', inline: 'start'});
};

export const focusOnElementStart = (el: any): void => {
    el?.scrollIntoView({ block: 'start', inline: 'start'});
};
